angular.module('octopusApp.tenants')
    .controller('TenantLayoutController', function ($scope, tenantState) {
        var self = this;
        self.tenant = null;
        self.tenantId = tenantState.tenantId;
        self.isLoading = tenantState.isLoading;
        self.isSaving = tenantState.isSaving;
        self.tenantState = tenantState;
        $scope.$watch(function () {
            return tenantState.tenant;
        }, function (tenant) {
            self.tenant = tenant;
        });
    }).provider('tenantState', function() {
        this.$get = function($stateParams, busy, octopusRepository) {
            var state = {
                isLoading: busy.create(),
                isSaving: busy.create(),
                tenantId: $stateParams.tenantId,
                tenantIdAsync: null
            };

            function load() {
                state.tenantIdAsync = octopusRepository.Tenants.get(state.tenantId);
                state.isLoading.promise(state.tenantIdAsync.then(function (tenant) {
                    state.tenant = tenant;
                }));
                return state.tenantIdAsync;
            }

            state.load = load;
            return state;
        };
    });


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/controllers/tenant_layout_controller.js
// module id = 5489368369389599
// module chunks = 1